import axios from "axios";

const fetchLabel = async () => {
  const response = await axios.get('/account/api/v1/labels');

  return response.data;
};

export default fetchLabel;
